export default __webpack_public_path__ + "static/media/new.8b9feb32.webp";